
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transfers",
      function () {
        return require("private-next-pages/transfers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transfers"])
      });
    }
  